import React from 'react';

interface IStatsBoxes {
    sessions: number;
    avgDuration: any;
    successSessions?: number;
    failedSessions?: number;
}

const StatsBoxes = ({
    sessions,
    avgDuration,
    successSessions,
    failedSessions
}: IStatsBoxes) => {
    const formatDuration = avgDuration?.replace(' seconds', '')
    return (
        <div className='my-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-4'>
            <div className='bg-white !rounded-md p-4'>
                <p className='mb-10'>No. of Sessions</p>
                <p className='mt-5 font-bold text-[17px]'>{sessions || 0}</p>
            </div>
            <div className='bg-white !rounded-md p-4'>
                <p className='mb-10'>Avg Session Duration</p>
                <p className='mt-5 font-bold text-[17px]'>{formatDuration || 0} s</p>
            </div>
            <div className='bg-white !rounded-md p-4'>
                <p className='mb-10'>Success Sessions</p>
                <p className='mt-5 font-bold text-[17px]'>{successSessions || 0}</p>
            </div>
            <div className='bg-white !rounded-md p-4'>
                <p className='mb-10'>Failed Sessions</p>
                <p className='mt-5 font-bold text-[17px]'>{failedSessions || 0}</p>
            </div>
        </div>
    )
}
export default StatsBoxes;